const getAnalyteStandardName = (analyte) => {
  const lowered = analyte.toLowerCase().replace(/ /g, '');

  if (lowered.indexOf('t3') > -1) {
    if (lowered.indexOf('rt3') > -1 || lowered.indexOf('reverse') > -1) {
      return 'Reverse T3';
    }
    if (lowered.indexOf('ft3') > -1 || lowered.indexOf('free') > -1) {
      return 'Free T3';
    }
  }

  if (lowered.indexOf('t4') > -1) {
    if (lowered.indexOf('ft4') > -1 || lowered.indexOf('free') > -1) {
      return 'Free T4';
    }
  }

  if (lowered.indexOf('tpo') > -1 || lowered.indexOf('thyroidperoxidase') > -1) {
    return 'TPO';
  }

  if (lowered.indexOf('tsh') > -1) {
    return 'TSH';
  }

  if (lowered.indexOf('vitamind') > -1) {
    return 'Vitamin D';
  }

  return analyte;
};

export const AnalytesUtils = {
  getAnalyteStandardName,
};
